// require("prismjs/themes/prism-ghcolors.css");
// require("prismjs/plugins/line-numbers/prism-line-numbers.css");
require('prismjs/plugins/command-line/prism-command-line.css');
